import debounce from 'lodash/debounce';
import ReactTooltip from 'react-tooltip';

export const rebuildReactTooltip = debounce(() => {
    ReactTooltip.rebuild();
}, 400, { leading: true });
